import { useState } from "react";

interface ColorSelectorForOrderProps {
  backgroundColors: string[];
  onColorSelect: (color: string) => void;
  preSelectedNotesColor: string;
}

const ColorSelectorForOrder = (props: ColorSelectorForOrderProps) => {
  const { backgroundColors, onColorSelect, preSelectedNotesColor } = props;
  const [selectedColor, setSelectedColor] = useState<string | null>(
    preSelectedNotesColor ?? "transparent",
  );

  /**
   * Handles the color selection toggle behavior.
   *
   * @description
   * If the clicked color is already selected, it deselects it by setting
   * the selection to null and notifying the parent with "transparent".
   * Otherwise, it selects the new color and notifies the parent.
   *
   * @param {string} backgroundColor - The color that was clicked
   */
  const handleColorToggle = (backgroundColor: string): void => {
    if (selectedColor === backgroundColor) {
      setSelectedColor("transparent");
      onColorSelect("transparent");
    } else {
      setSelectedColor(backgroundColor);
      onColorSelect(backgroundColor);
    }
  };

  return (
    <div className="color-selector-for-order-container flex gap-2">
      <div className="color-selector-for-order-label text-h11 font-semibold text-primaryGray-1">
        Highlight order by selecting a color :
      </div>
      <div className="color-selector-for-order-colors flex gap-2">
        {backgroundColors.map((backgroundColor) => (
          <SingleColorSelector
            key={backgroundColor}
            backgroundColor={backgroundColor}
            isSelected={selectedColor === backgroundColor}
            onClick={() => handleColorToggle(backgroundColor)}
          />
        ))}
      </div>
    </div>
  );
};

interface SingleColorSelectorProps {
  backgroundColor: string;
  isSelected: boolean;
  onClick: () => void;
}

const SingleColorSelector = (props: SingleColorSelectorProps) => {
  const { backgroundColor, isSelected, onClick } = props;
  return (
    <div
      className="color-selector-outer-container flex h-6 w-6 cursor-pointer items-center justify-center rounded-full border border-primaryGray-14 hover:border-primaryGray-10"
      style={{ borderColor: isSelected ? "#1f1f1f" : "#f5f5f5" }}
      onClick={onClick}
    >
      <div
        className="color-selector-inner-container h-4 w-4 rounded-full"
        style={{ backgroundColor: backgroundColor }}
      ></div>
    </div>
  );
};

export default ColorSelectorForOrder;
